"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initPrivacy = void 0;
const loginFormFieldIds = ['signInName', 'password'];
const forgotPasswordFormFieldIds = ['email'];
const registrationFormFieldIds = ['givenName', 'surname', 'inputCountryCode', 'telephoneNumber', 'extension_companyName', 'streetAddress', 'city', 'postalCode', 'combinedLocation', 'email', 'VerificationCode', 'accountType_customer', 'accountType_vendor', 'jobTitle', 'newPassword', 'reenterPassword', 'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes', 'extension_newsletterConsentChoice_AgreeToNewsletterConsentYes'];
const setPrivacyAttributes = elementIdArray => {
  elementIdArray.forEach(function (elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.setAttribute('data-sl', 'mask');
    }
  });
};
const initPrivacy = () => {
  setPrivacyAttributes(loginFormFieldIds);
  setPrivacyAttributes(forgotPasswordFormFieldIds);
  setPrivacyAttributes(registrationFormFieldIds);
};
exports.initPrivacy = initPrivacy;
//# sourceMappingURL=smartlook.js.map